export const isVolteoEmail = (email?: string | null): boolean => {
	const normalized = (email || "").toLowerCase();
	return (
		normalized.endsWith("@volteo.com") ||
		normalized.endsWith("@volteomaritime.com")
	);
};
